const htmlDIV = document.querySelector('#b2bCard').querySelector('div[name=uploadBody]');
// const typeDisplay = document.querySelector('#b2bDocsParntersCimena').querySelector('div[name=body]');
import auth from '../../tools/storage.js';

import tools from '../../tools/tools.js';

export default {

  cleanContainer() {
    htmlDIV.innerHTML = '';
  },


  drawDataInContainer(data) {

    htmlDIV.innerHTML = `
    <div class="reference-header">
        <div class="reference-column">№</div>
        <div class="reference-column">Ссылка:</div>
    </div>
    `;
    data.filter(el=> el.type != 3).forEach((item, index) => htmlDIV.insertAdjacentHTML('beforeend', this.getElement(item, index)));
    
  },

  getElement(item, index) {



    const typeDocs = ['Бланк','Договор', 'Отчетность'];
    return `
    
    <label class="reference-header" for="${item.id}" data-stock-id="${item.id}" >
        <div class="reference-column">${index + 1}</div>
        <div class="reference-column">${item.name ? ('<a href=https://storage.yandexcloud.net/fest-b2b/' + auth.currentFestival + '/pdf/' +  item.name + ' target="_blank">' + typeDocs[item.type] + ' -> ' + tools.dateStringFullAddTimeZone(item.timeUpload, 3) +'</a>') :' - '}</div>
      
        <input type="radio" id="${item.id}" data-stock-id="${item.id}" name="contact" value="email" class="d-none">
    </label>`;
  },

};
